import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";
import Marked from "marked";

/* packages */
import { WindowSize } from "../../lib-atomic-functions";
import { GlobalContext } from "../../lib-atomic-context";
import { ModuleContainerLg } from "../../lib-atomic-design-section";
/* packages */

/* module */
import Loader from "../loader";
/* module */

import CONFIG from "../config";

const index = observer((props) => {
  /* state */
  /* --- cms */
  /* -------------- */
  const { cms } = useContext(GlobalContext);
  /* -------------- */
  /* --- cms */
  /* state */
  const { width, height } = WindowSize();

  /* data props */
  const orderPage = cms.state.data.pages[6];
  const mediaPath = CONFIG.setup.assets.media;
  const media_01 = orderPage.media_01;
  const description_01 = {
    __html: orderPage.description_01 ? Marked(orderPage.description_01) : "",
  };
  const backgroundImage = "url(" + mediaPath + media_01.url + ")";
  /* data props */

  const fontResizer =
    width > 800
      ? "banner size4"
      : width > 500
      ? "banner size5"
      : "banner size6";
  return (
    <Fragment>
      <div style={{ backgroundImage }} className="bannerWrap">
        <section className={fontResizer}>
          <ModuleContainerLg>
            <div dangerouslySetInnerHTML={description_01}></div>
          </ModuleContainerLg>
        </section>
      </div>
    </Fragment>
  );
});

export default index;
